module.exports = __webpack_public_path__ + "static/media/place-of-worship.148aec54.svg";